import request from './axios'
export function getSceneList() {
  return request({
    url: `/lx/card/scene/list`,
    method: 'get'
  })
}
export function moduleList(params) {
  return request({
    url: `/lx/card/scene-doc/admin/sceneModuleList`,
    method: 'get',
    params
  })
}
// 表格数据
export function dataList(data) {
  return request({
    url: `/lx/fodder/back/list`,
    method: 'post',
    data
  })
}
// 奖项证书
export function getImageList(rootId) {
  return request({
    url: `/lx/fodder/image-module/tree?rootId=${rootId}`,
    method: 'get'
  })
}
// 表格数据
export function ImageData(data) {
  return request({
    url: `/lx/fodder/image-item/admin/page`,
    method: 'post',
    data
  })
}
// 预览页数
export function numPage(data) {
  return request({
    url: `/lx/api/document/lx-preview/getPageCount`,
    method: 'post',
    data
  })
}
